import { createContext } from "react";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { ITagValue } from "../../common/models/ITagValue";
import { ITagRegisterInfo } from "../../services/properties-data-service/Models";
import { LiveDataState, LiveDataStateItem } from "./LiveDataContextTypes";

export const LiveDataContext = createContext<[LiveDataState,
    (contextObject: IeLynxObject) => LiveDataStateItem | undefined, // get active state
    (contextObject: IeLynxObject, writeOnly?: boolean) => Promise<void>, // demand scan
    (contextObject: IeLynxObject) => Promise<void>, // cancel command
    (contextObject: IeLynxObject, values: ITagValue[]) => Promise<void>, // write down
    (registerInfo: ITagRegisterInfo) => Promise<void>, // test change register
    (contextObject: IeLynxObject) => Promise<void>, // get live strokes
    (pollingServer: string, acmObjectName: string, elynxObject: IeLynxObject) => Promise<void>, // get polling stats
] | undefined>(undefined);
